<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

        <!-- 左边 -->
        <div style="margin:5px;float:right">
            <el-button size="mini" type="success" @click="openModel">添加优惠券</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="name" label="名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="start_time" label="开始时间" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="end_time" label="结束时间" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="min_price" label="最低折扣价" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="order" label="折扣值" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <div style="float:right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>



        <el-dialog :title="names" :visible.sync="dialogVisible" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="优惠券名称">
                        <el-input v-model="ruleForm.name" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="ruleForm.type" placeholder="请选择" size="small" style="width:30%">
                            <el-option v-for="item in type_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="ruleForm.status" placeholder="请选择" size="small" style="width:30%">
                            <el-option v-for="item in status_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input v-model="ruleForm.total" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="折扣值">
                        <el-input v-model="ruleForm.value" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="最低折扣价">
                        <el-input v-model="ruleForm.min_price" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间">
                        <el-date-picker v-model="ruleForm.start_time" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间">
                        <el-date-picker v-model="ruleForm.end_time" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm.order" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="ruleForm.desc" placeholder="请输入内容" style="width:70%"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue"
    import common from '@/common/mixins/common.js';
    export default {
        inject: ['app', 'layout'],
        mixins: [common],
        components: {
            buttonSearch,

        },
        data() {
            return {
                tableData: [],
                loadings: false,
                height: null,
                pageSize: 15,
                curPage: 1,
                count: 0,
                page: '',
                names: '',
                dialogVisible: false,
                rules: {},
                type_options: [{
                        id: 0,
                        name: '固定金额'
                    },
                    {
                        id: 1,
                        name: '百分比'
                    }
                ],
                status_options: [{
                        id: 0,
                        name: '不生效'
                    },
                    {
                        id: 1,
                        name: '生效'
                    }
                ],
                ruleForm: {
                    name: '',
                    type: '',
                    status: '',
                    value: '',
                    min_price: '',
                    start_time: '',
                    end_time: '',
                    order: '',
                    desc: '',
                    total:''
                },
                eid: '',
                delid:'',


            }
        },
        computed: {

        },
        mounted() {
            let that = this
            that.search()
        },
        methods: {
            search() {
                let that = this
                that.loadings = true
                that.page = that.curPage
                let url = `/admin/coupon/${that.page}`;
                axios
                    .get(url, {
                        token: true
                    })
                    .then(response => {
                        // console.log(response.data.data.data);

                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                        that.loadings = false
                    })
                    .catch(error => {})
            },
            handleSizeChange(val){
                let that = this
                that.pageSize = val
                that.search()
            },
            handleCurrentChange(val){
                 let that = this
                that.curPage = val
                that.search()
            },
            openModel() {
                let that = this
                that.dialogVisible = true
                that.names = "新增"
                that.ruleForm.name = ''
                that.ruleForm.type = ''
                that.ruleForm.status = ''
                that.ruleForm.value = ''
                that.ruleForm.min_price = ''
                that.ruleForm.start_time = ''
                that.ruleForm.end_time = ''
                that.ruleForm.order = ''
                that.ruleForm.desc = ''
                 that.ruleForm.total = ''
            },
            subForm() {
                let that = this
                let urls = `/admin/coupon/${that.eid}`;
                if (that.names == "新增") {
                    axios
                        .post("/admin/coupon", {

                            name: that.ruleForm.name,
                            type: that.ruleForm.type,
                            status: that.ruleForm.status,
                            value: that.ruleForm.value,
                            min_price: that.ruleForm.min_price,
                            start_time: that.ruleForm.start_time,
                            end_time: that.ruleForm.end_time,
                            order: that.ruleForm.order,
                            desc: that.ruleForm.desc,
                            total:that.ruleForm.total
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.dialogVisible = false
                                that.search()
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                }
                if (that.names == "编辑") {
                    axios
                        .post(urls, {

                            name: that.ruleForm.name,
                            type: that.ruleForm.type,
                            status: that.ruleForm.status,
                            value: that.ruleForm.value,
                            min_price: that.ruleForm.min_price,
                            start_time: that.ruleForm.start_time,
                            end_time: that.ruleForm.end_time,
                            order: that.ruleForm.order,
                            desc: that.ruleForm.desc,
                            total:that.ruleForm.total
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.dialogVisible = false
                                that.search()
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                }

            },
            handleClick(row) {
                let that = this
                that.dialogVisible = true
                that.names = "编辑"
                that.eid = row.id
                that.ruleForm.name = row.name
                that.ruleForm.type = row.type
                that.ruleForm.status = row.status
                that.ruleForm.value = row.value
                that.ruleForm.min_price = row.min_price
                that.ruleForm.start_time = row.start_time
                that.ruleForm.end_time = row.end_time
                that.ruleForm.order = row.order
                that.ruleForm.desc = row.desc
                 that.ruleForm.total = row.total
            },
            // deleteClick(row){
            //    let that = this
            //    that.delid = row.id
            //    let url = `/admin/coupon/${that.delid}`;
            //     axios
            //         .get(url, {
            //             token: true
            //         })
            //         .then(response => {
                       
            //         })
            //         .catch(error => {})
            // }

        },
    }
</script>

<style>
</style>